import { useMemo } from 'react';
import {
    makeSelectMeetingMemberGuestBadge,
    MeetingMemberGuestBadge,
} from 'flow/selectors/meeting-selectors';
import { useAppSelector } from './useRedux';

/**
 * One memoized selector instance per call site (see
 * makeSelectContactDataForNumber) — shared by every video tile so the guest /
 * internal derivation isn't duplicated per tile component.
 */
const useMeetingMemberGuestBadge = (
    memberName: string | undefined,
): MeetingMemberGuestBadge => {
    const selectGuestBadge = useMemo(makeSelectMeetingMemberGuestBadge, []);
    return useAppSelector((state) => selectGuestBadge(state, memberName));
};

export default useMeetingMemberGuestBadge;
